/**
 * Verification utility functions for checking risk indicator codes
 */

import {
  BusinessVerificationCode,
  UserVerificationCode,
} from '../data/verifications';

// --------
// Business
// --------

export const hasBusinessNameIssue = (
  codes: BusinessVerificationCode[],
): boolean => {
  return codes.includes(BusinessVerificationCode.BUSINESS_NAME);
};

export const hasBusinessEINIssue = (
  codes: BusinessVerificationCode[],
): boolean => {
  return codes.includes(BusinessVerificationCode.BUSINESS_TIN_INVALID);
};

export const hasBusinessAddressIssue = (
  codes: BusinessVerificationCode[],
): boolean => {
  return (
    codes.includes(BusinessVerificationCode.BUSINESS_ADDRESS) ||
    codes.includes(BusinessVerificationCode.BUSINESS_ADDRESS_VACANT)
  );
};

// ----
// User
// ----

export const hasUserAddressIssue = (codes: UserVerificationCode[]): boolean => {
  return (
    codes.includes(UserVerificationCode.ADDRESS) ||
    codes.includes(UserVerificationCode.ADDRESS_TRANSIENT)
  );
};

export const hasUserFirstNameIssue = (
  codes: UserVerificationCode[],
): boolean => {
  return codes.includes(UserVerificationCode.FIRST_NAME);
};

export const hasUserLastNameIssue = (
  codes: UserVerificationCode[],
): boolean => {
  return codes.includes(UserVerificationCode.LAST_NAME);
};

export const hasUserDOBIssue = (codes: UserVerificationCode[]): boolean => {
  return codes.includes(UserVerificationCode.DATE_OF_BIRTH);
};

export const hasUserSSNIssue = (codes: UserVerificationCode[]): boolean => {
  return codes.includes(UserVerificationCode.SSN_TIN);
};
